import { render, staticRenderFns } from "./Goods.vue?vue&type=template&id=b13cbc78&scoped=true"
import script from "./Goods.vue?vue&type=script&lang=ts"
export * from "./Goods.vue?vue&type=script&lang=ts"
import style0 from "./Goods.vue?vue&type=style&index=0&id=b13cbc78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b13cbc78",
  null
  
)

export default component.exports